import enUS from "antd/lib/locale/en_US"
import ruRU from "antd/lib/locale/ru_RU"
import arEG from "antd/lib/locale/ar_EG"
import azAZ from "antd/lib/locale/az_AZ"
import bgBG from "antd/lib/locale/bg_BG"
import bnBD from "antd/lib/locale/bn_BD"
import byBY from "antd/lib/locale/by_BY"
import caES from "antd/lib/locale/ca_ES"
import csCZ from "antd/lib/locale/cs_CZ"
import daDK from "antd/lib/locale/da_DK"
import deDE from "antd/lib/locale/de_DE"
import elGR from "antd/lib/locale/el_GR"
import esES from "antd/lib/locale/es_ES"
import etEE from "antd/lib/locale/et_EE"
import faIR from "antd/lib/locale/fa_IR"
import fiFI from "antd/lib/locale/fi_FI"
import frBE from "antd/lib/locale/fr_BE"
import gaIE from "antd/lib/locale/ga_IE"
import glES from "antd/lib/locale/gl_ES"
import heIL from "antd/lib/locale/he_IL"
import hiIN from "antd/lib/locale/hi_IN"
import hrHR from "antd/lib/locale/hr_HR"
import huHU from "antd/lib/locale/hu_HU"
import hyAM from "antd/lib/locale/hy_AM"
import idID from "antd/lib/locale/id_ID"
import isIS from "antd/lib/locale/is_IS"
import itIT from "antd/lib/locale/it_IT"
import jaJP from "antd/lib/locale/ja_JP"
import kaGE from "antd/lib/locale/ka_GE"
import kkKZ from "antd/lib/locale/kk_KZ"
import kmKH from "antd/lib/locale/km_KH"
import knIN from "antd/lib/locale/kn_IN"
import koRK from "antd/lib/locale/ko_KR"
import kuIQ from "antd/lib/locale/ku_IQ"
import ltLT from "antd/lib/locale/lt_LT"
import lvLV from "antd/lib/locale/lv_LV"
import mkMK from "antd/lib/locale/mk_MK"
import mlIN from "antd/lib/locale/ml_IN"
import mnMN from "antd/lib/locale/mn_MN"
import msMY from "antd/lib/locale/ms_MY"
import neNP from "antd/lib/locale/ne_NP"
import nlNL from "antd/lib/locale/nl_NL"
import plPL from "antd/lib/locale/pl_PL"
import ptBR from "antd/lib/locale/pt_BR"
import ptPT from "antd/lib/locale/pt_PT"
import roRO from "antd/lib/locale/ro_RO"
import skSK from "antd/lib/locale/sk_SK"
import slSI from "antd/lib/locale/sl_SI"
import srRS from "antd/lib/locale/sr_RS"
import svSE from "antd/lib/locale/sv_SE"
import taIN from "antd/lib/locale/ta_IN"
import thTH from "antd/lib/locale/th_TH"
import trTR from "antd/lib/locale/tr_TR"
import ukUA from "antd/lib/locale/uk_UA"
import urPK from "antd/lib/locale/ur_PK"
import viVN from "antd/lib/locale/vi_VN"
import zhCN from "antd/lib/locale/zh_CN"
import zhTW from "antd/lib/locale/zh_TW"

export const getProviderLocale = (locale) => {
    switch (locale) {
        case "zh-cht": {
            return "zh-TW"
        }
        default: {
            return locale
        }
    }
}

export const getLocale = (locale) => {
    switch (locale) {
        case "az": {
            return azAZ
        }
        case "ar": {
            return arEG
        }
        case "bn": {
            return bnBD
        }
        case "bg": {
            return bgBG
        }
        case "by": {
            return byBY
        }
        case "ca": {
            return caES
        }
        case "fr-ca":
        case "fr": {
            return frBE
        }
        case "cs": {
            return csCZ
        }
        case "da": {
            return daDK
        }
        case "de": {
            return deDE
        }
        case "el": {
            return elGR
        }
        case "en": {
            return enUS
        }
        case "es-chl":
        case "es-mx": {
            return esES
        }
        case "et": {
            return etEE
        }
        case "fa": {
            return faIR
        }
        case "fi": {
            return fiFI
        }
        case "ga": {
            return gaIE
        }
        case "gl": {
            return glES
        }
        case "he": {
            return heIL
        }
        case "hi": {
            return hiIN
        }
        case "hr": {
            return hrHR
        }
        case "hu": {
            return huHU
        }
        case "hy": {
            return hyAM
        }
        case "ru": {
            return ruRU
        }
        case "id": {
            return idID
        }
        case "is": {
            return isIS
        }
        case "it": {
            return itIT
        }
        case "ja": {
            return jaJP
        }
        case "ka": {
            return kaGE
        }
        case "kk": {
            return kkKZ
        }
        case "km": {
            return kmKH
        }
        case "kn": {
            return knIN
        }
        case "ko": {
            return koRK
        }
        case "ku": {
            return kuIQ
        }
        case "lt": {
            return ltLT
        }
        case "lv": {
            return lvLV
        }
        case "mk": {
            return mkMK
        }
        case "ml": {
            return mlIN
        }
        case "mn": {
            return mnMN
        }
        case "ms": {
            return msMY
        }
        case "ne": {
            return neNP
        }
        case "nl": {
            return nlNL
        }
        case "pl": {
            return plPL
        }
        case "pt-br": {
            return ptBR
        }
        case "pt": {
            return ptPT
        }
        case "ro": {
            return roRO
        }
        case "sk": {
            return skSK
        }
        case "sl": {
            return slSI
        }
        case "sr": {
            return srRS
        }
        case "sv": {
            return svSE
        }
        case "ta": {
            return taIN
        }
        case "th": {
            return thTH
        }
        case "rt":
        case "tr": {
            return trTR
        }
        case "uk": {
            return ukUA
        }
        case "ur": {
            return urPK
        }
        case "vi": {
            return viVN
        }
        case "zh": {
            return zhCN
        }
        case "zh-cht": {
            return zhTW
        }
        default:
            return enUS
    }
}
